module.exports = __webpack_public_path__ + "img/cd23d.ffc12a2c.svg";